/**
 * @bos/portal3 — the root route `/`. Sends a logged-out visitor to the sign-in entry and
 * a logged-in one straight to the dashboard (the topology the milestone asks for), so the
 * root is never a dead marketing page. While the session is still being probed it shows a
 * brief, calm placeholder rather than flashing the wrong destination.
 */
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { PATHS } from '../routes';
import { Brand } from '../components/Brand';

export function IndexRedirect() {
  const { status } = useAuth();

  if (status === 'loading') {
    return (
      <div className="centered" aria-busy="true">
        <div className="centered__inner">
          <Brand size="lg" />
          <p className="centered__lede">One moment…</p>
        </div>
      </div>
    );
  }

  return <Navigate to={status === 'authenticated' ? PATHS.dashboard : PATHS.login} replace />;
}
